import React from "react";
import CycleRenderer from "./CycleRenderer";
import PropTypes from "prop-types";
import {get, isEqual} from "lodash";
import {getEventDate} from "./utils";
import EventTypes from "@wesstron/utils/Api/constants/eventTypes";
import {withTranslation} from "react-i18next";

class MommyRenderer extends React.Component {
    state = {
        hoveredID: "",
    };

    isTattooedPiglet(mommy) {
        return (
            mommy && mommy.event.EvCode === EventTypes.SEPARATION_TO_MOMMY_GILTS
        );
    }

    isReclassifiedPiglet(mommy) {
        return mommy && get(mommy, "event.EvData.ReclassifyTime");
    }

    getPigletsSummary() {
        const {
            cycle: {mommys = []},
        } = this.props;
        return mommys.reduce(
            (prev, current) => prev + get(current, "event.EvData.PiCnt", 1),
            0
        );
    }

    getPigletsContent(mommy, showAnmNo1 = false) {
        if (showAnmNo1) {
            if (this.isReclassifiedPiglet(mommy)) return 1;
            return get(mommy, "event.EvData.AnmNo1", "-");
        }
        return get(mommy, "event.EvData.PiCnt");
    }

    getClassName(evID, mommy, isGilt = false) {
        const {hoveredID} = this.state;
        let className = "cell-wrapper";
        if (isGilt) {
            className += " cursor-not-allowed";
        } else {
            if (hoveredID === evID) className += " error";
            else className += " success";
        }
        return className;
    }

    onMouseEnter = (event) => {
        const cell = get(event, "currentTarget");
        if (cell) {
            const EvID = cell.id.split(" ")[0];
            this.setState({
                hoveredID: EvID,
            });
        }
    };

    onMouseLeave = () => {
        this.setState({
            hoveredID: "",
        });
    };

    getTitle(mommy) {
        const {t} = this.props;
        if (this.isTattooedPiglet(mommy)) {
            if (this.isReclassifiedPiglet(mommy)) {
                return t("errors.noEditReclassifyPiglet");
            }
            return t("errors.noEditTattooPiglet");
        }
        return "";
    }

    render() {
        const {
            cycle: {mommys, key},
            expanded: {rows},
            isAdvanced,
            tooltipContent,
            cycleRenderClass,
            deletionMode,
            onDeleteClick,
            onDoubleEventClick,
            printing,
            isInterrupted,
        } = this.props;
        const rowValue = rows.find((o) => o === key);
        const lastMommy = mommys[mommys.length - 1];
        if (!lastMommy) {
            return (
                <>
                    {isAdvanced && (
                        <CycleRenderer isInterrupted={isInterrupted} />
                    )}
                    <CycleRenderer
                        comment={cycleRenderClass && tooltipContent}
                        isInterrupted={isInterrupted}
                        deletionMode={deletionMode}
                    />
                </>
            );
        }
        const operators = mommys[0].operators;
        const modifications = mommys[0].modifications;
        const isLastTattooedPiglet = this.isTattooedPiglet(lastMommy);
        return (
            <>
                {isAdvanced && (
                    <CycleRenderer>
                        {isAdvanced && (isEqual(key, rowValue) || printing) ? (
                            mommys.map((mommy, index) => {
                                const {
                                    event: {EvID},
                                } = mommy;
                                const isTattooedPiglet =
                                    this.isTattooedPiglet(mommy);
                                return (
                                    <div
                                        className={this.getClassName(
                                            EvID,
                                            mommy,
                                            isTattooedPiglet
                                        )}
                                        key={index}
                                        id={`${EvID} EvTime`}
                                        title={this.getTitle(mommy)}
                                        onDoubleClick={
                                            !isTattooedPiglet
                                                ? onDoubleEventClick
                                                : undefined
                                        }
                                        onMouseEnter={
                                            deletionMode && !isTattooedPiglet
                                                ? this.onMouseEnter
                                                : undefined
                                        }
                                        onMouseLeave={
                                            deletionMode && !isTattooedPiglet
                                                ? this.onMouseLeave
                                                : undefined
                                        }
                                        onClick={
                                            deletionMode && !isTattooedPiglet
                                                ? onDeleteClick
                                                : undefined
                                        }>
                                        {getEventDate(mommy)}
                                    </div>
                                );
                            })
                        ) : (
                            <div
                                className={this.getClassName(
                                    lastMommy.event.EvID,
                                    lastMommy,
                                    isLastTattooedPiglet
                                )}
                                id={`${lastMommy.event.EvID} EvTime`}
                                title={this.getTitle(lastMommy)}
                                onDoubleClick={
                                    !isLastTattooedPiglet
                                        ? onDoubleEventClick
                                        : undefined
                                }
                                onMouseEnter={
                                    deletionMode && !isLastTattooedPiglet
                                        ? this.onMouseEnter
                                        : undefined
                                }
                                onMouseLeave={
                                    deletionMode && !isLastTattooedPiglet
                                        ? this.onMouseLeave
                                        : undefined
                                }
                                onClick={
                                    deletionMode && !isLastTattooedPiglet
                                        ? onDeleteClick
                                        : undefined
                                }>
                                {getEventDate(lastMommy)}
                            </div>
                        )}
                    </CycleRenderer>
                )}
                <CycleRenderer
                    comment={cycleRenderClass && tooltipContent}
                    isAdvanced={isAdvanced}
                    modifications={modifications}
                    operators={operators}
                    deletionMode={deletionMode}>
                    {isAdvanced && (isEqual(key, rowValue) || printing) ? (
                        mommys.map((mommy, index) => {
                            const {
                                event: {EvID},
                            } = mommy;
                            const isTattooedPiglet =
                                this.isTattooedPiglet(mommy);
                            return (
                                <div
                                    className={this.getClassName(
                                        EvID,
                                        mommy,
                                        isTattooedPiglet
                                    )}
                                    key={index}
                                    id={`${EvID} EvData.PiCnt`}
                                    title={this.getTitle(mommy)}
                                    onDoubleClick={
                                        !isTattooedPiglet
                                            ? onDoubleEventClick
                                            : undefined
                                    }
                                    onMouseEnter={
                                        deletionMode && !isTattooedPiglet
                                            ? this.onMouseEnter
                                            : undefined
                                    }
                                    onMouseLeave={
                                        deletionMode && !isTattooedPiglet
                                            ? this.onMouseLeave
                                            : undefined
                                    }
                                    onClick={
                                        deletionMode && !isTattooedPiglet
                                            ? onDeleteClick
                                            : undefined
                                    }>
                                    {this.getPigletsContent(
                                        mommy,
                                        isTattooedPiglet
                                    )}
                                </div>
                            );
                        })
                    ) : (
                        <div
                            className={this.getClassName(
                                lastMommy.event.EvID,
                                lastMommy,
                                isLastTattooedPiglet
                            )}
                            id={`${lastMommy.event.EvID} EvData.PiCnt`}
                            title={this.getTitle(lastMommy)}
                            onDoubleClick={
                                !isLastTattooedPiglet
                                    ? onDoubleEventClick
                                    : undefined
                            }
                            onMouseEnter={
                                deletionMode && !isLastTattooedPiglet
                                    ? this.onMouseEnter
                                    : undefined
                            }
                            onMouseLeave={
                                deletionMode && !isLastTattooedPiglet
                                    ? this.onMouseLeave
                                    : undefined
                            }
                            onClick={
                                deletionMode && !isLastTattooedPiglet
                                    ? onDeleteClick
                                    : undefined
                            }>
                            {this.getPigletsSummary()}
                        </div>
                    )}
                </CycleRenderer>
            </>
        );
    }
}

MommyRenderer.propTypes = {
    cycle: PropTypes.shape({
        mommys: PropTypes.array.isRequired,
    }).isRequired,
};

export default withTranslation()(MommyRenderer);
